import vars from '../helpers';

let isStart = false;

const init = () => {
	if (window.innerWidth <= 1800) {
		return;
	}

	const $figure1 = $('.js-intro-figure-1');
	const $figure2 = $('.js-intro-figure-2');
	const $image = $('.js-intro-image');

	const k = 1800;
	const deltafigure1 = 60;
	const deltafigure2 = -147;
	// const deltafigure3 = -147;

	const getRes = (delta) => {
		let koef = (window.innerWidth - k) / window.innerWidth;
		let num = delta / (2600 - k) * 2600;

		return Math.floor(num * koef);
	};

	const setParams = () => {
		isStart = true;

		$figure1.css({
			left: `calc(50% + ${getRes(deltafigure1)}px)`, // stylelint-disable-line
		});

		$figure2.css({
			left: `calc(50% + ${getRes(deltafigure2)}px)`, // stylelint-disable-line
		});

		$image.css({
			left: `calc(50% + ${getRes(deltafigure2)}px)`, // stylelint-disable-line
		});
	};

	setParams();

	vars.$window.on('resize', () => {
		if (window.innerWidth >= 1800) {
			setParams();
		}

		if (window.innerWidth < 1800 && isStart) {
			$image.css({
				left: '50%',
			});

			isStart = false;
		}
	});
};

export default {
	init,
};
